import { Edit, translate } from "react-admin";
import React from "react";

import HotlineForm from "./HotlineForm";

const HotlineTitle = ({ translate, record }) => {
  return (
    <span>
      {`${translate("hotline.hotline")}`} {record ? `"${record.name}"` : ""}
    </span>
  );
};

const Title = translate(HotlineTitle);

export const HotlineEdit = props => (
  <Edit title={<Title />} {...props}>
    <HotlineForm />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/hotline/HotlineEdit.js